import { render, staticRenderFns } from "./HomeProfile.vue?vue&type=template&id=dfa6a6b0&"
import script from "./HomeProfile.vue?vue&type=script&lang=js&"
export * from "./HomeProfile.vue?vue&type=script&lang=js&"
import style0 from "./HomeProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports